(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_quantity-group"] && !Shopify.designMode) return;
  try {
    (() => {
    const parseChoice = (choice) => {
      const data = choice?.querySelector('[data-quantity-option-product-data]');
      if (!data) return null;
      try { return JSON.parse(data.textContent); } catch (_error) { return null; }
    };

    const initGroup = (group) => {
      if (!group || group.dataset.quantityGroupReady === 'true') return;

      const form = group.closest('form');
      const root = group.closest('[data-section-id]');
      if (!form || !root) return;
      group.dataset.quantityGroupReady = 'true';

      const optionName = (group.dataset.productOptionName || '').trim();
      const currency = group.dataset.currency || 'USD';
      const locale = group.dataset.locale || document.documentElement.lang || 'en-US';
      const radios = [...group.querySelectorAll('[data-quantity-option-radio]')];
      const productOptionGroups = [...form.querySelectorAll('[data-hsw5-option-position]')];
      const rawQuantityGroup = productOptionGroups.find((field) => (
        optionName && (field.dataset.hsw5OptionName || '').trim().toLowerCase() === optionName.toLowerCase()
      ));

      if (group.dataset.hideProductOption === 'true' && rawQuantityGroup) rawQuantityGroup.hidden = true;

      let currentCatalog = null;
      try {
        currentCatalog = JSON.parse(root.querySelector('[data-hsw5-ab-products]')?.textContent || '{}').primary || null;
      } catch (_error) {}

      const variantIdInput = form.querySelector('[data-hsw5-variant-id]');
      const atc = form.querySelector('[data-hsw5-atc]');
      const atcText = atc?.querySelector('[data-button-text]');
      const price = root.querySelector('[data-hsw5-price]');
      const compare = root.querySelector('[data-hsw5-compare-price]');
      const saving = root.querySelector('[data-hsw5-saving]');
      const stickyPrice = root.querySelector('[data-hsw5-sticky-price]');
      const stickyCompare = root.querySelector('[data-hsw5-sticky-compare]');
      const stickyTitle = root.querySelector('[data-hsw5-sticky-title] strong');
      const stickyImage = root.querySelector('.watch-product-hero__sticky-image');
      const stickySubmit = root.querySelector('[data-hsw5-sticky-submit]');

      const money = (cents) => {
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
        } catch (_error) {
          return '$' + ((Number(cents) || 0) / 100).toFixed(2);
        }
      };

      const selectedFormOptions = () => productOptionGroups.map((field) => (
        field.querySelector('[data-hsw5-option-value]:checked')?.value || ''
      ));

      const resolveVariant = (choice) => {
        const catalog = parseChoice(choice);
        if (!catalog?.variants?.length) return null;

        const identifier = String(catalog.variantIdentifier || '').trim();
        if (identifier) {
          const explicit = catalog.variants.find((variant) => (
            String(variant.id) === identifier
            || variant.title === identifier
            || variant.options?.includes(identifier)
          ));
          if (explicit) return { catalog, variant: explicit };
        }

        const mappedValue = String(catalog.productOptionValue || '').trim();
        if (mappedValue && optionName) {
          const optionIndex = (catalog.options || []).findIndex((name) => (
            String(name).trim().toLowerCase() === optionName.toLowerCase()
          ));

          if (optionIndex >= 0) {
            const selected = selectedFormOptions();
            const matches = catalog.variants.filter((variant) => variant.options?.[optionIndex] === mappedValue);
            const best = matches.sort((a, b) => {
              const score = (variant) => (variant.options || []).reduce((total, value, index) => (
                total + (index === optionIndex ? 2 : selected[index] === value ? 1 : 0)
              ), variant.available ? .25 : 0);
              return score(b) - score(a);
            })[0];
            if (best) return { catalog, variant: best };
          }
        }

        return {
          catalog,
          variant: catalog.variants.find((variant) => variant.available) || catalog.variants[0]
        };
      };

      const updateChoiceCard = (choice, resolved = resolveVariant(choice)) => {
        if (!choice || !resolved?.variant) return resolved;

        const { catalog, variant } = resolved;
        const radio = choice.querySelector('[data-quantity-option-radio]');
        const choicePrice = choice.querySelector('[data-quantity-option-price]');
        const choiceCompare = choice.querySelector('[data-quantity-option-compare-price]');
        const variantPrice = Number(variant.price) || 0;
        const comparePrice = Number(variant.compare_at_price) || 0;
        const showComparePrice = catalog.showComparePrice !== false && comparePrice > variantPrice;

        if (choicePrice) choicePrice.textContent = money(variantPrice);
        if (choiceCompare) {
          choiceCompare.hidden = !showComparePrice;
          choiceCompare.textContent = showComparePrice ? money(comparePrice) : '';
        }
        if (radio) radio.disabled = !variant.available;

        return resolved;
      };

      const refreshChoiceCards = () => {
        radios.forEach((radio, index) => {
          const choice = radio.closest('[data-quantity-option]');
          const resolved = updateChoiceCard(choice);
          if (!choice || !resolved) return;
          choice.dataset.quantityOptionIndex = index;
          choice.dataset.productId = resolved.catalog.productId;
          choice.dataset.variantId = resolved.variant.id;
        });
      };

      const syncChoiceFromVariant = (variant) => {
        if (!variant?.id) return null;

        refreshChoiceCards();
        const matchingRadio = radios.find((radio) => (
          String(radio.closest('[data-quantity-option]')?.dataset.variantId) === String(variant.id)
        ));
        if (!matchingRadio || matchingRadio.disabled) return null;

        matchingRadio.checked = true;
        return matchingRadio;
      };

      const updatePurchaseUi = ({ catalog, variant }) => {
        if (!variant || !variantIdInput) return;
        variantIdInput.value = variant.id;

        const variantPrice = Number(variant.price) || 0;
        const comparePrice = Number(variant.compare_at_price) || 0;
        const discounted = comparePrice > variantPrice;
        const selectedChoice = radios.find((radio) => radio.checked)?.closest('[data-quantity-option]');
        const customSaving = parseChoice(selectedChoice)?.savingsText || '';
        const savingText = customSaving || (discounted
          ? 'Save ' + Math.round((comparePrice - variantPrice) * 100 / comparePrice) + '%'
          : '');

        if (price) price.textContent = money(variantPrice);
        if (compare) {
          compare.hidden = !discounted;
          compare.textContent = discounted ? money(comparePrice) : '';
        }
        if (saving) {
          saving.hidden = !savingText;
          saving.textContent = savingText;
        }
        if (stickyPrice) stickyPrice.textContent = money(variantPrice);
        if (stickyCompare) {
          stickyCompare.hidden = !discounted;
          stickyCompare.textContent = discounted ? money(comparePrice) : '';
        }
        if (stickyTitle && catalog.productTitle) stickyTitle.textContent = catalog.productTitle;
        if (stickyImage && catalog.featuredImage) stickyImage.src = catalog.featuredImage;

        if (atc) atc.disabled = !variant.available;
        if (stickySubmit) stickySubmit.disabled = !variant.available;
        if (atcText) {
          const originalLabel = atcText.dataset.quantityOriginalLabel
            || atcText.textContent.split('·')[0].trim()
            || 'Add to Cart';
          atcText.dataset.quantityOriginalLabel = originalLabel;
          atcText.textContent = variant.available
            ? originalLabel + ' · ' + money(variantPrice)
            : 'Sold out';
        }
      };

      const applyChoice = (radio) => {
        const choice = radio?.closest('[data-quantity-option]');
        const resolved = updateChoiceCard(choice);
        if (!resolved) return;

        const mappedValue = choice.dataset.productOptionValue || '';
        const sameProduct = currentCatalog && String(resolved.catalog.productId) === String(currentCatalog.id);
        if (sameProduct && mappedValue && rawQuantityGroup) {
          const matchingInput = [...rawQuantityGroup.querySelectorAll('[data-hsw5-option-value]')]
            .find((input) => input.value === mappedValue);
          if (matchingInput && !matchingInput.checked) {
            matchingInput.checked = true;
            matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        updatePurchaseUi(resolved);
        form.dispatchEvent(new CustomEvent('quantity-group:change', {
          bubbles: true,
          detail: {
            productId: resolved.catalog.productId,
            productTitle: resolved.catalog.productTitle,
            quantityOptionId: choice.dataset.quantityOptionId || '',
            variant: resolved.variant
          }
        }));
      };

      radios.forEach((radio) => radio.addEventListener('change', () => {
        if (radio.checked) applyChoice(radio);
      }));

      productOptionGroups.forEach((field) => {
        field.querySelectorAll('[data-hsw5-option-value]').forEach((input) => {
          input.addEventListener('change', () => {
            queueMicrotask(() => {
              refreshChoiceCards();
              let selectedRadio = radios.find((radio) => radio.checked && !radio.disabled);
              if (!selectedRadio) {
                selectedRadio = radios.find((radio) => !radio.disabled);
                if (selectedRadio) selectedRadio.checked = true;
              }
              if (selectedRadio) applyChoice(selectedRadio);
            });
          });
        });
      });

      root.addEventListener('hsw5:variant-change', (event) => {
        syncChoiceFromVariant(event.detail?.variant);
      });

      refreshChoiceCards();

      let selected = radios.find((radio) => radio.checked && !radio.disabled);
      if (!selected) {
        selected = radios.find((radio) => !radio.disabled);
        if (selected) selected.checked = true;
      }
      if (selected) queueMicrotask(() => applyChoice(selected));
    };

    const init = (scope = document) => {
      scope.querySelectorAll?.('[data-quantity-group]').forEach(initGroup);
      if (scope.matches?.('[data-quantity-group]')) initGroup(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
